<template>

  <div id="bg">
  <div id="wrapper">

    <LandingHeader />

    <h1>Our Mission</h1>

    <div class="about-container">

      <h2>We founded Outside Voice in 2026 with the goal of being the world’s best tool for gathering consumer insights and feedback.</h2>
      <h2>We believe that this requires combining two fundamental building blocks,<br/><span>Video</span> and <span>WhatsApp.</span></h2>
      <h3>Why <span>Video?</span></h3>
      <p>It’s 2026 and half the world has super computers with high definition cameras in their pockets. Why are we still relying on tedious mobile web forms for customer feedback? We have the potential to get HD video answers from people sharing their thoughts, opinions and feedback. Think of how much richer a Zoom conversation is than a one word text and you can see where we’re going with this.  Our goal is to bring online forms as close as possible to the fidelity and nuance of an in-person conversation.</p>
      <h3>Why <span>WhatsApp?</span></h3>
      <p>If you had to pick the one app you think people feel most comfortable in, chances are it would be WhatsApp. It’s where people naturally share their lives and talk with friends every moment of the day. We believe that WhatsApp is where people feel most comfortable sharing their thoughts and opinions which makes it the natural best fit for where businesses should connect with them when gathering insights and feedback.</p>

    </div>

  </div>

  <LandingFooter />

  </div>


</template>

<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';
export default {

  name: 'about',

  components: {
    LandingHeader,
    LandingFooter
  },

  created() {
  }

}
</script>


<style lang="scss" scoped>

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}

#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  margin: 0 auto;
  padding-top: 180px;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}

h1{
  color: #13D298;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
}

.about-container{
  width: 60%;
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  padding: 50px 40px;
  background-color: #0A212D;
  border-radius: 6px;
  color: white;
  h2, h3{
    color: white;
  }
  h2{
    font-size: 20px;
    line-height: 37px;
    margin-bottom: 30px;
    font-weight: 600;
    span{
      color: #13D298;
    }
  }
  h3{
    font-size: 19px;
    line-height: 29px;
    font-weight: 600;
    margin-top: 35px;
    span{
      color: #13D298;
    }
  }
  p{
    font-size: 15px;
    line-height: 27px;
    font-weight: 400;
  }
}



// Mobile Styles
@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
  padding-top: 40px;
}

h1{
  font-size: 25px;
  margin-top: 65px;
  margin-left: 15px;
}

.about-container{
  width: 100%;
  padding: 35px 30px;
  margin-top: 35px;
  margin-bottom: 30px;
  h2, h3{
    font-size: 17px;
    line-height: 30px;
  }
  p{
    font-size: 15px;
    line-height: 26px;
  }
}

}

</style>
